import React, { Fragment, useContext, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import AuthContext from "../../context/auth/AuthContext";
import AlertContext from "../../context/alert/AlertContext";
import ConfigContext from "../../context/config/ConfigContext";
import GroupContext from "../../context/group/GroupContext";
import ActionMenu from "./../layout/ActionMenu";
import Preloader from "./../layout/Preloader";
import DataTable from "../common/DataTable";
import Button from "react-bootstrap/Button";
import useTokenCheck from "../../hooks/useTokenCheck";
import usePageTitle from "../../hooks/usePageTitle";

const GroupManagement = (props) => {
  const authContext = useContext(AuthContext);
  const { token } = authContext;
  const configContext = useContext(ConfigContext);
  const { loaded, getConfigValue, getConfigValueByCode } = configContext;
  const alertContext = useContext(AlertContext);
  const { setAlert, clearAlerts } = alertContext;
  const groupContext = useContext(GroupContext);
  const {
    groups,
    getGroups,
    groupsLoading,
    removeGroups,
    setCurrentGroup,
    clearCurrentGroup,
  } = groupContext;
  const history = useHistory();
  let groupData;
  if (groups) {
    groupData = groups.data;
  }
  // const [refresh, setRefresh] = useState(false);

  // useEffect(() => {
  //   if (!groups || refresh) {
  //     onSearchGroups(refresh);
  //   }
  //   setRefresh(false);
  //   //eslint-disable-next-line
  // }, [refresh]);

  useEffect(() => {
    if (!groups) {
      onSearchGroups();
    }
    if (loaded) {
      const pageSize = getConfigValue(
        "generalConfig",
        "page_size",
        "App_Config"
      );
      setPageSize(pageSize);
    }
    //eslint-disable-next-line
  }, []);

  usePageTitle({
    appTitle: props.appTitle,
    pageTitle: "Group List",
  });

  //eslint-disable-next-line
  const [searchCriteria, setSearchCriteria] = useState({
    filterType: "all",
    filterValue: "",
  });
  const [pageSize, setPageSize] = useState(25);
  //   const { filterType, filterValue } = searchCriteria;

  // const onSearchChange = (e) =>
  //   setSearchCriteria({ ...searchCriteria, filterValue: e.target.value });

  const onSearchGroups = async (refresh) => {
    try {
      console.log("###Criteria: ", searchCriteria);
      const res = await getGroups(searchCriteria, token);
      console.log("$$RES: ", res);
      if (res.msgCode && !refresh) {
        const msg = getConfigValueByCode(
          "generalConfig",
          "RESPONSE_MSG",
          res.msgCode
        );
        clearAlerts();
        setAlert(msg, "warning");
      } else if (res.data.length === 0) {
        clearAlerts();
        const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 469);
        setAlert(msg, "warning");
      } else {
        setTableAlert(
          "Search is successfully completed and matching records are displayed in the table"
        );
      }
    } catch (err) {
      console.log("$ERR:", err);
      if (err.msgCode) {
        const msg = getConfigValueByCode(
          "generalConfig",
          "RESPONSE_MSG",
          err.msgCode
        );
        clearAlerts();
        setAlert(msg, "warning");
      }
      clearAlerts();
      const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
      setAlert(msg, "danger");
    }
  };
  const getCurrentGroup = (group) => {
    console.log("$$$GROUP filter:", group);
    const groupItem = groupData.filter((item, index) => index === group)[0];
    console.log("$$$GROUP filtered Item:", groupItem);
    if (groupItem) {
      console.log("$$$GROUP filter ID:", groupItem.id);
      return groupItem;
    } else {
      console.log("$$$NULL ID:");
      return null;
    }
  };

  //setCurrentCard
  const selectCurrentGroup = async (groupId) => {
    try {
      const group = getCurrentGroup(groupId);
      // groupDispatch({
      //   type: SET_CURRENT_GROUP,
      //   payload: groupId,
      // });
      //   await loadGroup({ groupId: groupId }, token);
      setCurrentGroup(group);
      history.push("/group-detail");
    } catch (err) {
      clearAlerts();
      const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
      setAlert(msg, "danger");
    }
  };

  const getSelectedIds = (selectedRows) => {
    const selectedGroups = groupData.filter(
      (item, index) => selectedRows[index]
    );
    return selectedGroups.map((item) => item.id);
  };

  const processDeleteResult = async (results) => {
    console.log("###results:", results);
    const successGroups = results.filter((item) => item.status === "SUCCESS");
    const failedGroups = results.filter((item) => item.status === "ERROR");
    console.log("###successGroups:", successGroups);
    console.log("###failedGroups:", failedGroups);
    const successGroupNames = successGroups.map((item) => {
      console.log("###successGroupItem:", item);
      console.log("###successGroupItem:", item.groupNames);
      return item.groupNames;
    });
    const failedGroupNames = failedGroups.map((item) => {
      console.log("###failedGroupNamesItem:", item);
      console.log("###failedGroupNamesItem:", item.groupNames);
      return item.groupNames;
    });
    console.log("###successGroupNames:", successGroupNames);
    console.log("###failedGroupNames:", failedGroupNames);
    // console.log("###successGroups[0].msgCode:", successGroups[0].msgCode);
    // console.log("###failedGroups[0].msgCode:", failedGroups[0].msgCode);
    const successMsgCode =
      successGroups.length > 0 ? successGroups[0].msgCode : 0;
    const failureMsgCode =
      failedGroups.length > 0 ? failedGroups[0].msgCode : 0;
    let successMsg =
      successMsgCode !== 0
        ? getConfigValueByCode("generalConfig", "RESPONSE_MSG", successMsgCode)
        : "";
    let failureMsg =
      failureMsgCode !== 0
        ? getConfigValueByCode("generalConfig", "RESPONSE_MSG", failureMsgCode)
        : "";
    if (successMsgCode !== 0)
      successMsg = successMsg.replace("{0}", successGroupNames);
    if (failureMsgCode !== 0)
      failureMsg = failureMsg.replace("{0}", failedGroupNames);
    console.log("###successMsgCode:", successMsgCode);
    console.log("###failureMsgCode:", failureMsgCode);
    console.log("###successMsg:", successMsg);
    console.log("###failureMsg:", failureMsg);
    // const msg = successMsg.concat(successMsg !== "" ? " \n" : "", failureMsg);
    const msg = { successMsg, failureMsg };

    const res = { status: failureMsgCode !== 0, msg };
    console.log("###Res:", res);
    return res;
  };
  const onRemoveGroup = async (selectedRows) => {
    clearAlerts();
    //Get selected Data Set
    let ids = getSelectedIds(selectedRows);
    if (!selectedRows || Object.keys(selectedRows).length === 0) return;
    console.log("onRemoveGroup...", selectedRows);
    try {
      const res = await removeGroups({ ids }, token);
      console.log("###DelResult:", res);
      const rsMsg = await processDeleteResult(res.data);
      console.log("###DelResult:", rsMsg);
      if (rsMsg) {
        if (rsMsg.msg?.successMsg !== "")
          setAlert(rsMsg.msg.successMsg, "success");
        if (rsMsg.status) setAlert(rsMsg.msg.failureMsg, "danger");
        onSearchGroups(true);
      }
      // let msg = getConfigValueByCode(
      //   "generalConfig",
      //   "RESPONSE_MSG",
      //   res.msgCode
      // );
      // clearAlerts();
      // console.log("###DelResult msg:", msg);
      // setAlert(msg, res.status === "ERROR" ? "danger" : "info");
      // // setAlert("Groups successfully removed", "success");
      // if (res.status !== "ERROR") onSearchGroups(true);
    } catch (err) {
      clearAlerts();
      const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
      setAlert(msg, "danger");
    }
  };

  const { hasTokenExpired } = useTokenCheck();
  const onCreateGroup = async (e) => {
    clearAlerts();
    await hasTokenExpired();
    //Get changed Data Set
    clearCurrentGroup();
    history.push("group-detail");
  };

  const columnDefs = [
    {
      Header: "GROUP NAME",
      accessor: "groupname",
      className: "drillColumn",
      customCell: "action",
      onClickAction: (rowIndex, columnId, value) => {
        // We also turn on the flag to not reset the page
        console.log(`Clicked for(${rowIndex},${columnId}) :`, value);
        selectCurrentGroup(rowIndex);
      }, // This is a custom function that we supplied to our table instance
      fieldType: "link",
      filter: "text",
    },
    {
      Header: "GROUP DETAILS",
      accessor: "groupdetails",
      canFilter: false,
    },
  ];

  const [tableAlert, setTableAlert] = useState(" ");
  console.log("setTableAlert", tableAlert);

  return (
    <Fragment>
      {groupsLoading && <Preloader />}
      <ActionMenu resetUseIdleTimer={props.resetUseIdleTimer} />
      <div
        className="patronPage"
        role="main"
        ref={props.mainContentRef}
        tabIndex="-1"
      >
        <div className="patronPage__titleBar">
          <h2 id="pageHeaders" className="patronPage__pageTitle">
            GROUP LIST
          </h2>
          <div id="pageHeader" className="patronPage__pageTitle__action">
            <Button
              variant="primary"
              id="createGroup"
              aria-label="Create New Group "
              onClick={onCreateGroup}
            >
              CREATE NEW GROUP
            </Button>
          </div>
        </div>
        <div aria-live="polite" style={{ color: "transparent", height: "1px" }}>
          {tableAlert}
        </div>
        <div className="patronPage__content">
          {groupData && groupData.length > 0 && (
            <div className="patronPage__tableListing">
              <DataTable
                data={groups.data}
                columnDefs={columnDefs}
                pageSize={pageSize}
                tableAction="REMOVE SELECTED GROUP"
                onTableAction={onRemoveGroup}
                turnOffFilter={true}
                enableGlobalFilter={true}
                enableRowSelect={true}
              />
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default GroupManagement;
